import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '~environment';

@Component({
  selector: 'app-registro2',
  templateUrl: './registro2.component.html',
  styleUrls: ['./registro2.component.scss']
})
export class Registro2Component implements OnInit {

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    // if (this.rutaActiva.snapshot.params['id']) {
    //   sessionStorage.setItem('Tienda', this.rutaActiva.snapshot.params['id']);
    //   this.router.navigate(['']);
    // } else {
    //   sessionStorage.setItem('Tienda', '');
    //   this.router.navigate(['']);
    // }
    if (this.activatedRoute.snapshot.params.id) {
      const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com/register/' + this.activatedRoute.snapshot.params.id : 'https://accounts.triidy.com/register/' + this.activatedRoute.snapshot.params.id;
      window.open(url, '_self')
    } else {
      const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com/register/' : 'https://accounts.triidy.com/register/';
      window.open(url, '_self')
    }
  }

}
